import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { PageEvent } from '@tesla/ng-tds';
import { AutoInvoiceSupplierSourceMap, SupplierChannelGridValues, SupplierChannelPropertyValues, SupplierChannels } from 'app/profile/models/supplier.model';
import { EInvoicingService } from 'app/profile/services/einvoicing-channels.service';
import { SelectSupplierChannelList } from 'app/profile/store/app.selector';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { I18nService } from 'app/shared/services/i18n.service';
import { BehaviorSubject, Subscription } from 'rxjs-compat';

@Component({
  selector: 'app-einvoicing-channels-grid',
  templateUrl: './einvoicing-channels-grid.component.html',
  styleUrls: ['./einvoicing-channels-grid.component.scss']
})
export class EinvoicingChannelsGridComponent implements OnInit, OnDestroy{

  supplierChannelsPropertyValue: SupplierChannelPropertyValues[];
  @Input('gridData') supplierChannels: SupplierChannelGridValues[];
  
  supplierChannelsData: SupplierChannels[];
  skip = 0;
  pageSize = 10;
  subscription: Subscription = new Subscription;
  code: string = '';
  gridViewData: BehaviorSubject<Array<SupplierChannelGridValues>> = null;

  displayedColumns = [
      "Entity Name",
      "Region", 
      "Country", 
      "Category", 
      "Channels" 
  ]

  totalRows = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100, 250];
  currentPageSize = 10;
    
  constructor(private route: ActivatedRoute,
    private store: Store<SupplierState>,
    public translateService: I18nService,
    private eInvoicingService: EInvoicingService) { 
    this.gridViewData = new BehaviorSubject([]);
  }

  ngOnInit(): void {
    let supplierCodeSub = this.route.parent.params.subscribe((params) =>{
      if(!params['code']){
        return;
      }

      this.code = params['code'];
             
      let channelListSub = this.store.pipe(select(SelectSupplierChannelList)).subscribe((channelList) => {
        if(!channelList){
          return;
        }

        this.supplierChannelsPropertyValue = channelList;
        this.totalRows = channelList.length;
        this.currentPageSize = this.pageSizeOptions[0];
        this.loadGrid(this.currentPageSize, 0);
        
      });

      this.subscription.add(channelListSub);   
    });

    this.subscription.add(supplierCodeSub);
  }

  loadGrid(take: number, skip: number) {
    if(!this.supplierChannels){
      this.supplierChannels = this.getSupplierGridData(this.supplierChannelsPropertyValue);
    }

    let channelList = this.supplierChannels.slice(skip, skip + take);
    this.gridViewData.next(channelList);
  }

  pageChange(pageChange: PageEvent) {
    const { previousPageIndex, pageSize, pageIndex } = pageChange;
    this.currentPageSize = pageSize;

    if (previousPageIndex === pageIndex) {
      this.loadGrid(pageSize, 0);
    } else {
      const from = pageIndex * pageSize;
      const to = from + pageSize;
      this.loadGrid(pageSize, from);
    }
  }

  getSupplierGridData(channelList: SupplierChannelPropertyValues[]) : SupplierChannelGridValues[]{
    const supplierChannelList: SupplierChannelGridValues[] = [];

    if(!channelList){
      return supplierChannelList;
    }

    for(let i = 0; i < channelList.length; i++){
      const channel = {
        entityName : channelList[i].entityName.newValue,
        countryCode: channelList[i].country.newValue,
        supplierCategory: channelList[i].supplierTypes.newValue.join(', '),
        region: channelList[i].region.newValue, 
        sources: this.validChannels(channelList[i].sources.newValue)
      }  
            
      supplierChannelList.push(channel);
    }   

    return supplierChannelList
  }

  validChannels(supplierChannels: AutoInvoiceSupplierSourceMap[]): {SourceName: string, Enabled: boolean, Supplierid: number}[] {
    return this.eInvoicingService.validChannelsForChannelSelection(supplierChannels, true);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }



}
